import { useMemo } from 'react';

import { SelectOption } from '@/shared/config';
import { useAppSelector } from '@/shared/hooks';

import { userModel } from '@/entities/user';

import { makeCountryOptions } from '../lib';

import { useCountriesData } from './useCountriesData';

export const useCountries = (): SelectOption[] => {
  const { countries } = useCountriesData();

  const { locale } = useAppSelector(userModel.selectors.selectUserSettings);

  return useMemo(
    () => makeCountryOptions(countries, locale),
    [countries, locale],
  );
};
